(function ($) {
  Drupal.behaviors.responsiveTabsFormatter = {
    attach: function (context) {
      var $formatters = $('.js-responsive-tabs-formatter', context);

      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var $tab_container = $('.responsive-tabs-formatter__wrapper', $formatter);
        var $tablist = $('.resp-tabs-list', $formatter);
        var $tabs = $('.js-responsive-tab-item', $formatter);
        var $tabheaders = $('.js-responsive-tab-item__label', $formatter);

        $tabheaders.each(function (i, obj) {
          var $header = $(obj);
          var $new_header = $('<li role="tab" tabindex="' + i + '"></li>').html($header.html());

          $tablist.append($new_header);
        });
        $tabheaders.hide();

        var options = {
          width: 'auto'
        };

        options['activate'] = function () {
          $('.resp-tab-active', $formatter).resize(); // trigger a resize event
        };

        $tab_container.easyResponsiveTabs(options);
      });
    }
  };
})(jQuery);
